import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Accordion)`
  display: flex;
  flex-direction: column;
  background: ${(p) => p.theme.palette.grey[200]};
  padding: ${(p) => p.theme.spacing(1, 1.5)};

  &.MuiAccordion-root {
    &::before {
      display: none;
    }
  }
  &.Mui-expanded {
    gap: ${(p) => p.theme.spacing(1.5)};
    box-shadow: none;
    border: 1px solid ${(p) => p.theme.palette.grey[300]};
    border-radius: ${(p) => p.theme.spacing(0.5)};
    background: ${(p) => p.theme.palette.common.white};
  }
  border-radius: ${(p) => p.theme.spacing(0.5)};

  & .MuiAccordionSummary-root {
    min-height: ${(p) => p.theme.spacing(3)} !important;
    padding: 0 !important;
  }
`;

export const Summary = styled(AccordionSummary)`
  & .MuiAccordionSummary-content {
    margin: 0 !important;
    overflow: hidden !important;
  }
`;

export const Detail = styled(AccordionDetails)`
  padding: 0 !important;
`;
